import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton'
import { SxProps } from '@mui/material/styles'

interface SkeletonLoaderProps {
  sx?: SxProps
  variant?: 'card' | 'list' | 'dashboard'
}

export const SkeletonLoader = ({ sx = {}, variant = 'list' }: SkeletonLoaderProps) => {
  return (
    <Stack sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      {variant === 'list' && (
        <Stack gap={24}>
          <Skeleton height={25} variant="rounded" width={150} />
          <Skeleton height={50} variant="rounded" />
          <Skeleton height={50} variant="rounded" />
          <Skeleton height={50} variant="rounded" />
        </Stack>
      )}

      {variant === 'card' && (
        <Stack gap={24}>
          <Skeleton height={50} variant="rounded" />
          <Stack direction="row" gap={24}>
            <Skeleton height={300} variant="rounded" width="20%" />
            <Skeleton height={300} variant="rounded" width="80%" />
          </Stack>
        </Stack>
      )}

      {variant === 'dashboard' && (
        <Stack gap={24}>
          <Skeleton height={75} variant="rounded" />
          <Stack gap={24}>
            <Stack direction="row" gap={24}>
              <Skeleton height={250} variant="rounded" width="75%" />
              <Skeleton height={250} variant="rounded" width="25%" />
            </Stack>
            <Stack direction="row" gap={24}>
              <Skeleton height={250} variant="rounded" width="75%" />
              <Skeleton height={250} variant="rounded" width="25%" />
            </Stack>
            <Stack direction="row" gap={24}>
              <Skeleton height={250} variant="rounded" width="75%" />
              <Skeleton height={250} variant="rounded" width="25%" />
            </Stack>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}
